if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalWindow {
    constructor() {
      super();
      this.modalOverlay = this.querySelector('.product-media-modal__content');
      this.closeButton = this.querySelector('.product-media-modal__toggle');
      this.onKeyDown = this.onKeyDown.bind(this);

      this._originalParent = this.parentNode;
      this._nextSibling = this.nextElementSibling;

      // Tracks the last media the user was viewing inside the modal
      this._currentModalMediaId = null;

      if (this.modalOverlay) {
        this.modalOverlay.addEventListener('click', (event) => {
          if (
            !event.target.closest('.product-media-modal__wrapper--default') &&
            !event.target.closest('.slider-button') &&
            !event.target.closest('.slider__grid-item') &&
            !event.target.closest('.image-magnify-full-size')
          ) {
            this.hide();
          }
        });
      }
      this.closeButton.addEventListener('click', ()=> this.hide())

    }

    /**
     * Reads the currently visible slide in the modal's slider by scroll position and returns its media ID.
     * data-media-id lives on the <img> / deferred-media child, not on the <li> itself.
     */
    _getVisibleModalMediaId() {
      const slider = this.querySelector('[id^="Slider-Gallery-"]');
      if (!slider) return null;

      const sliderScrollLeft = slider.scrollLeft;
      const slides = Array.from(slider.querySelectorAll('li[id^="Slide-"]'));
      if (!slides.length) return null;

      let closestSlide = slides[0];
      let closestDist = Infinity;
      slides.forEach(slide => {
        const dist = Math.abs(slide.offsetLeft - sliderScrollLeft);
        if (dist < closestDist) {
          closestDist = dist;
          closestSlide = slide;
        }
      });

      const mediaEl = closestSlide.querySelector('[data-media-id]');
      return mediaEl ? mediaEl.getAttribute('data-media-id') : null;
    }

    hide() {
      // ZGŁOSZENIE KLIENTA: Zapobiegamy natywnemu autoscrollowi przeglądarki do miniatury klikniętej by otworzyć lightbox.
      // Kiedy ModalWindow.hide() odpala removeTrapFocus(this.openedBy), focus wracał na starą miniaturę,
      // co wyzwalało scroll, który w global.js wymuszał znowu niewłaściwe zdjęcie jako aktywne.
      const thumbnailsList = document.querySelector('[id^="GalleryThumbnails"]');
      if (thumbnailsList) {
         const firstThumbBtn = thumbnailsList.querySelector('.thumbnail-list__item button');
         if (firstThumbBtn) this.openedBy = firstThumbBtn;
      } else {
         const firstMediaBtn = document.querySelector('[id^="Slider-Gallery"] .product__media-item:not(.product__media-item--hide) modal-opener button');
         if (firstMediaBtn) this.openedBy = firstMediaBtn;
      }

      document.dispatchEvent(new CustomEvent('product-modal:close'));

      super.hide();
      document.body.removeEventListener('keydown', this.onKeyDown);

      if (this._originalParent) {
        if (this._nextSibling) {
          this._originalParent.insertBefore(this, this._nextSibling);
        } else {
          this._originalParent.appendChild(this);
        }
      }
    }

    show(opener) {
      document.body.appendChild(this);

      super.show(opener);
      this.showActiveMedia();
      document.body.addEventListener('keydown', this.onKeyDown);

      // Start tracking the current slide via scroll and arrow-button clicks
      this._attachModalTracking();
    }

    _attachModalTracking() {
      const slider = this.querySelector('[id^="Slider-Gallery-"]');
      if (!slider) return;

      // Debounced scroll handler: update tracked ID after scroll settles
      if (this._scrollTracker) {
        slider.removeEventListener('scroll', this._scrollTracker);
      }
      this._scrollDebounce = null;
      this._scrollTracker = () => {
        clearTimeout(this._scrollDebounce);
        this._scrollDebounce = setTimeout(() => {
          this._currentModalMediaId = this._getVisibleModalMediaId();
        }, 150);
      };
      slider.addEventListener('scroll', this._scrollTracker);

      // Also hook prev/next buttons so arrow navigation updates the tracker instantly
      this.querySelectorAll('.slider-button').forEach(btn => {
        btn.addEventListener('click', () => {
          // Give global.js time to finish its scroll animation before reading
          setTimeout(() => {
            this._currentModalMediaId = this._getVisibleModalMediaId();
          }, 400);
        });
      });
    }

    onKeyDown(event) {
      if (event.code === 'ArrowRight') {
        const nextBtn = this.querySelector('.slider-button--next');
        if (nextBtn) nextBtn.click();
      }
      if (event.code === 'ArrowLeft') {
        const prevBtn = this.querySelector('.slider-button--prev');
        if (prevBtn) prevBtn.click();
      }
    }

    showActiveMedia() {
      this.querySelectorAll('img').forEach(image => image.removeAttribute('loading'));

      if (!this.openedBy) return;
      
      let currentMediaId = this.openedBy.getAttribute("data-media-id");
      
      if (!currentMediaId) {
        // Try finding closest parent with data-media-id
        const closest = this.openedBy.closest('[data-media-id]');
        if (closest) {
          currentMediaId = closest.getAttribute("data-media-id");
        } else {
           // Fallback: If clicked inside an image, maybe the parent LI has it?
           // Sometimes the click target is the image element itself.
           if (this.openedBy.tagName === 'IMG') {
             const parentLi = this.openedBy.closest('li');
             if (parentLi && parentLi.hasAttribute('data-media-id')) {
                currentMediaId = parentLi.getAttribute('data-media-id');
             }
           }
        }
      }

      // Seed the tracker with the initial media shown on open
      this._currentModalMediaId = currentMediaId;

      this.querySelectorAll('[data-media-id]').forEach((element) => {
        const isMatch = element.getAttribute('data-media-id') === currentMediaId;
        element.classList.toggle('active', isMatch);
      });

      const activeMedia = this.querySelector(`[data-media-id="${currentMediaId}"]`);
      if (!activeMedia) return;

      const dataMediaAlt = activeMedia.dataset.mediaAlt;

      if (dataMediaAlt) {
        this.querySelectorAll('[data-media-alt]').forEach(element => {
          element.classList.toggle('product__media-item--variant--alt', element.getAttribute('data-media-alt') === dataMediaAlt);
        });
      }

      // Ensure active media is visible
      if (activeMedia.classList.contains('slider__grid-item')) {
        activeMedia.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }

      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

      if (
        activeMedia.nodeName === 'DEFERRED-MEDIA' &&
        activeMediaContent?.querySelector('.js-youtube, video, .js-vimeo')
      ) {
        activeMedia.loadContent();
      }

      document.dispatchEvent(new CustomEvent('image:show', { detail: { mediaId: currentMediaId } }));
      document.dispatchEvent(new CustomEvent('product-modal:open', { detail: currentMediaId }));
    }
  });
}